export default __webpack_public_path__ + "images/casaDefault.827ea45216109b1ec3660b5671e02f67.jpg";